import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UnrSettingsService } from '../../services/settings/settings.service';
import { SettingKeyEnum } from '../../services/settings/setting-key.enum';
import { WelcomeGuard } from './welcome.guard';
import { SliderService } from './slider.service';
import { Subscription } from 'rxjs';


export interface Slide {
  title: string;
}

@Component({
  selector: 'unr-welcome',
  templateUrl: 'welcome.html',
  styleUrls: ['welcome.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomePage implements OnInit, OnDestroy {
 
  slides: Slide[] = [
    { title: 'Welcome to Unrestricted.' },
    { title: 'What kind of a driver are you?' },
    { title: 'Adventurer' },
    { title: 'Driver' },
    { title: 'Thank you for using Unrestricted.' }
  ];

  // sliderOptions: SwiperOptions = {
  //   pagination: { clickable: true },
  //   initialSlide: 1,
  //   spaceBetween: 20,
  // };

  @ViewChild('swiperEl', { static: false }) swiperEl?: ElementRef;

  private resetSubscription?: Subscription;
  baseUrl: string;

  constructor(
    private domSanitizer: DomSanitizer,
    private router: Router,
    private unrSettingsService: UnrSettingsService,
    private welcomeGuard: WelcomeGuard,
    private sliderService: SliderService
  ) {
    
  }

  ngOnInit(): void {
    this.resetSubscription = this.sliderService.getReset$().subscribe(() => {
      setTimeout(() => {
        const swiper = this.swiperEl?.nativeElement.swiper;
        swiper?.slideTo(0, 0);
        swiper?.update();
      }, 1000);
    });
  }

  ngOnDestroy(): void {
    this.resetSubscription?.unsubscribe();
  }
  getSlideImage(index: number): string {
  const baseUrl = window.location.hostname.includes('mrconceptual.online')
    ? 'https://mrconceptual.online/adeel_api/unristricted/assets/welcome'
    : 'assets/welcome';

  return `${baseUrl}/welcome-${index}.jpg`;
}


  dismiss(): void {
    this.unrSettingsService.saveSetting(SettingKeyEnum.SHOW_WELCOME_SCREEN, false);
    this.goToRouteListScreen();
  }

  continue(): void {
    this.unrSettingsService.saveSetting(SettingKeyEnum.SHOW_WELCOME_SCREEN, true);
    this.goToRouteListScreen();
  }

  private goToRouteListScreen(): void {
    this.welcomeGuard.hasSeenWelcomeScreen = true;
    this.router.navigate(['roadtrips']);
  }
}
